export default __webpack_public_path__ + "static/media/liquid-figure-min-v2.c9f2935e.png";